import { useEffect, useRef } from 'react';

/**
 * Runs `callback` when the page is served from the back/forward cache, which restores the JS state
 * the supporter left behind rather than starting fresh.
 */
export function useOnBfcacheRestore(callback: () => void): void {
	const callbackRef = useRef(callback);

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		const runOnRestore = (event: PageTransitionEvent) => {
			if (event.persisted) callbackRef.current();
		};

		window.addEventListener('pageshow', runOnRestore);

		return () => window.removeEventListener('pageshow', runOnRestore);
	}, []);
}
